export const CONVERSION_OPTIMIZATION_STATUSES = {
    ACTIVE: 'active',
    COMPLETED: 'completed',
    DEVELOPING: 'developing',
    UPCOMING: 'upcoming'
};
//# sourceMappingURL=conversion-optimization-statuses.js.map